// LEGACY: Uses @ion/components. New code should use @metarouter-private/mr-mui components instead.
import React, { useState } from 'react';
import { useConsentCategoriesTableContext } from '../../../../context/consentCategoriesTableContext';
import { useRemoveConsentCategory } from '@ion/api';
import { MrButtonList, MrErrorModal } from '@ion/components';
import { Typography } from '@metarouter-private/mr-mui';
import { Button } from '@metarouter-private/mr-mui';

export const DeleteCategory = () => {
  const [errorMsg, setErrorMsg] = useState(false);
  const { onCloseModal, selectedCategory } = useConsentCategoriesTableContext();
  const [deleteCategory] = useRemoveConsentCategory({
    onCompleted: () => {
      onCloseModal();
    },
    onError: err => {
      setErrorMsg(err?.errorMsg);
    },
  });
  const onDeleteCategory = () => {
    deleteCategory({
      consentCategoryId: selectedCategory.id,
      name: selectedCategory.name,
      code: selectedCategory.code,
    });
  };

  return (
    <>
      <div className="header">
        <Typography variant="h5">{`Delete ${selectedCategory.displayName}?`}</Typography>
      </div>

      <div className="content">
        <Typography>
          Please confirm that you want to permanently delete
          <strong>{` ${selectedCategory.displayName}`}</strong>
        </Typography>

        <MrButtonList
          styleNames="marginTop"
          buttons={[
            <Button data-test-id="deleteCategoryButton" key="create" color="error" onClick={onDeleteCategory}>
              Delete
            </Button>,
            <Button key="cancel" variant="outlined" color="secondary" onClick={onCloseModal}>
              Cancel
            </Button>,
          ]}
        />
      </div>
      {errorMsg && (
        <MrErrorModal
          header="Error Deleting Consent Category"
          errorMessage={errorMsg}
          closeModal={() => setErrorMsg(false)}
        />
      )}
    </>
  );
};
